module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB4AAAAUCAIAAAAVyRqTAAAAuklEQVRIx2NgUKvHg/4fV8OD8OtlGDV6MBp9doE8EFHN6Lc7lR+sV4QY5GTCBUQQNlAQKEWR0f+OqZlocvTliz7coGSuzQFEQAaQCxQESlEaIOs6pGz0OYGM+mRhIAIygFygIBXCGug6dTm2X4dVIUYDGUAuUJA60Rhoz3N6nhzEaCADyKVaCmlMFXY05tKQZwMiIAPIpZrR15YrLGmQiPfiAyIgA8ilcrqGRyP1s8zkYjEgGi1DRpjRAD6mVREZzTPoAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./client/src/images/flags/bb.png
// module id = 777
// module chunks = 0